import React, { useContext, useEffect } from 'react';
import { useFormikContext } from 'formik';
import ColorEntryInput from '../ColorEntryInput';
import ColorToolsContext from '../../context/ColorToolsContext';
import colorToolsUtils from '../../../utils/colorToolsUtils';

const ColorEntryAddColor = () => {
    const { values } = useFormikContext();
    const { addColor } = values;
    const { setColorOnStage } = useContext(ColorToolsContext);

    useEffect(() => {
        if (colorToolsUtils.isValidColor(addColor)) {
            setColorOnStage(addColor);
        }
    }, [addColor]);

    return <ColorEntryInput name="addColor" showColorPicker={false} />;
};

export default ColorEntryAddColor;
